export default function HorizontalSeparator() {
    return <div className="flex justify-center pb-4 pt-2">
        <hr className="w-[60%] border-t-2 border-white rounded-full" />
    </div>
}